import {useState} from "react";
import { Outlet } from "react-router-dom";
import TopBar from "../Components/TopBar";
import Footer from "../Components/Footer";


function Root() {
    const [title, setTitle] = useState('');
    const [count, setCount] = useState(null);

    return (
        <div className="flex flex-col min-h-screen">
            <TopBar title={title} count={count} />
            <Outlet context={[setTitle, setCount]}/>
            <Footer />
        </div>
    );
}

export default Root;